import React, { FunctionComponent } from "react";
import { Provider as ReduxStore } from "react-redux";
import { AppProvider } from "./AppProvider";
import { store } from "store";
import AppLayout from "./AppLayout";

export const App: FunctionComponent = () => (
    <ReduxStore store={store}>
        <AppProvider>
            <AppLayout />
        </AppProvider>
    </ReduxStore>
);
